/* eslint-disable */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Upload } from 'antd'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

import { font, greys } from 'assets/themes/theme-default'
import svg from 'assets/svg'
import { Modal, Drawer } from 'core/components/ui'
import SVG from 'core/components/svg'
import TitleIcon from 'core/layouts/title-icon'
import { isMobile } from 'react-device-detect'

import Requester from 'core/requesters/Requester'

const StyledUpload = styled(Upload)`
  &&& .ant-upload-wrapper,
  &&& .ant-upload {
    width: 100%;
  }

  &&& .ant-upload.ant-upload-select {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  && .ant-upload-select-picture-card {
    width: 100%;
    height: 124px;
  }
`
const UploadPlaceholder = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8px 6px;
  gap: 2px;
  line-height: 1.2;
`
const UploadPlaceholderTitle = styled.div`
  margin-top: 4px;
  font-size: ${font.size.base};
  color: ${greys.dark1};
`
const UploadPlaceholderMeta = styled.div`
  font-size: ${font.size.xs};
  color: ${greys.dark2};
  font-style: italic;
  line-height: 1.25;
`
const Icon = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: ${greys.dark1};
  vertical-align: middle;
  cursor: pointer;
`

const DamagePicturesModal = ({ intl, ...props }) => {
  const [previewPicture, setPreviewPicture] = useState()
  const [modalVisible, setModalVisible] = useState(false)

  const getBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  const handlePreview = async picture => {
    if (!picture.previewUrl) {
      picture.previewUrl = await getBase64(picture.originFileObj)
    }
    setPreviewPicture(picture.previewUrl)
    setModalVisible(true)
  }
  const handleCancelPreview = () => {
    setModalVisible(false)
  }

  const handleDownload = file => {
    const a = document.createElement('a')
    a.href = file.url
    a.target = '_blank'
    a.download = file.url.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <>
      {!isMobile ? (
        <>
          <Modal visible={props.visible} destroyOnHidden onCancel={props.onClose} footer={null}>
            <TitleIcon
              title={intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-title' })}
              small
            />
            <section>
              <span>{props.title}</span>
            </section>
            <section>
              <StyledUpload
                headers={{
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('bearer')).jwt}`
                }}
                action={`${Requester.API.urlFileRender}/files/temporary`}
                onChange={props.onChange}
                onRemove={props.onRemove}
                onPreview={handlePreview}
                onDownload={handleDownload}
                method="POST"
                fileList={props.pictures}
                defaultFileList={props.pictures}
                showUploadList={{
                  showPreviewIcon: true,
                  showDownloadIcon: true,
                  showRemoveIcon: true
                }}
                listType="picture-card"
                multiple
                accept="image/*"
                beforeUpload={file => props.isFileAccepted(file)}
                maxCount={5}
                disabled={props.pictures && props.pictures.length === 5}
              >
                <UploadPlaceholder>
                  <Icon svg={svg.plus} />
                  <UploadPlaceholderTitle>
                    {intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-upload-button' })}
                  </UploadPlaceholderTitle>
                  <UploadPlaceholderMeta>
                    {intl.formatMessage({ id: 'upload.max_size' }, { value: 20 })}
                  </UploadPlaceholderMeta>
                  <UploadPlaceholderMeta>
                    {intl.formatMessage({
                      id: 'tradeIn-defaults-pictures-modal-max-count-defaults'
                    })}
                  </UploadPlaceholderMeta>
                </UploadPlaceholder>
              </StyledUpload>
              <Modal visible={modalVisible} footer={null} onCancel={handleCancelPreview}>
                <img alt="Preview" style={{ width: '100%' }} src={previewPicture} />
              </Modal>
            </section>
          </Modal>
        </>
      ) : (
        <>
          <Drawer
            placement="bottom"
            height="326"
            width="700px"
            visible={props.visible}
            onClose={() => props.onClose()}
            className="globaldealer-modal-vehicle-list"
            title={<span>{props.title}</span>}
          >
            <section>
              <StyledUpload
                headers={{
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('bearer')).jwt}`
                }}
                action={`${Requester.API.urlFileRender}/files/temporary`}
                onChange={props.onChange}
                onRemove={props.onRemove}
                onPreview={handlePreview}
                onDownload={handleDownload}
                method="POST"
                fileList={props.pictures}
                defaultFileList={props.pictures}
                showUploadList={{
                  showPreviewIcon: true,
                  showDownloadIcon: true,
                  showRemoveIcon: true
                }}
                listType="picture-card"
                multiple
                accept="image/*"
                beforeUpload={file => props.isFileAccepted(file)}
                maxCount={5}
                disabled={props.pictures && props.pictures.length === 5}
              >
                <UploadPlaceholder>
                  <Icon svg={svg.plus} />
                  <UploadPlaceholderTitle>
                    {intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-upload-button' })}
                  </UploadPlaceholderTitle>
                  <UploadPlaceholderMeta>
                    {intl.formatMessage({ id: 'upload.max_size' }, { value: 20 })}
                  </UploadPlaceholderMeta>
                  <UploadPlaceholderMeta>
                    {intl.formatMessage({
                      id: 'tradeIn-defaults-pictures-modal-max-count-defaults'
                    })}
                  </UploadPlaceholderMeta>
                </UploadPlaceholder>
              </StyledUpload>
            </section>
          </Drawer>
          <Drawer
            visible={modalVisible}
            footer={null}
            onClose={handleCancelPreview}
            placement="bottom"
            height="326"
          >
            <img alt="Preview" style={{ width: '100%' }} src={previewPicture} />
          </Drawer>
        </>
      )}
    </>
  )
}

DamagePicturesModal.propTypes = {
  intl: PropTypes.shape().isRequired,
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  pictures: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  isFileAccepted: PropTypes.func.isRequired
}

export default injectIntl(DamagePicturesModal)
